// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__3-8Ix","radioRow":"SimpleQuestionBuilderModal_radioRow__2QZJE"};